'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _values = require('babel-runtime/core-js/object/values');

var _values2 = _interopRequireDefault(_values);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _components = require('components');

var _config = require('../../config');

var _config2 = _interopRequireDefault(_config);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _htmlToReact = require('html-to-react');

var _reactRedux = require('react-redux');

var _reactRouterRedux = require('react-router-redux');

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _semanticUiReact = require('semantic-ui-react');

var _personalDetails = require('redux/modules/personalDetails');

var personalDetails = _interopRequireWildcard(_personalDetails);

var _professionalDetails = require('redux/modules/professionalDetails');

var professionalDetails = _interopRequireWildcard(_professionalDetails);

var _miscellaneousInfo = require('redux/modules/miscellaneousInfo');

var miscellaneousInfo = _interopRequireWildcard(_miscellaneousInfo);

var _infoBlock = require('redux/modules/infoBlock');

var info = _interopRequireWildcard(_infoBlock);

var _templateData = require('redux/modules/templateData');

var templateActions = _interopRequireWildcard(_templateData);

var _saveUserData = require('redux/modules/saveUserData');

var saveActions = _interopRequireWildcard(_saveUserData);

var _company = require('redux/modules/company');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Home = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    user: state.auth.user,
    template_id: state.templateData.template_id,
    template_data: state.templateData.template_data,
    templateDataComplete: state.templateData,
    user_data: state.saveUserData,
    company_data: state.company,
    user_data_loaded: state.saveUserData.loaded,
    user_data_loading: state.saveUserData.loading,
    user_data_fail: state.saveUserData.user_data_fail,
    resume_name: state.templateData.resume_name,
    user_data_id: state.templateData.user_data_id,
    ReactGA: state.company.ReactGA,
    base_url: state.company.base_url,
    show_resume_edit_label: state.company.show_resume_edit_label,
    basic_builder: state.company.basic_builder,
    basic_builder_design: state.templateData.design_template_id,
    max_resumes: state.company.max_resumes,
    type_of_document: state.company.type_of_document,
    subscribed: state.auth.subscribed,
    full_sso_data: state.auth.full_data,
    sso_detail: state.auth.sso_detail
  };
}, {
  pushState: _reactRouterRedux.push,
  cleanTemplateData: _templateData.clean,
  deleteUserData: saveActions.deleteUserData,
  saveUserData: saveActions.save,
  loadUserData: saveActions.load,
  cleanInfo: info.clean,
  updatePersonalDetails: personalDetails.updateBlock,
  addInfo: info.addBlock,
  choose_template: templateActions.chooseTemplate,
  loadDesignTemplateData: templateActions.loadDesignTemplateData,
  chooseUserDataID: templateActions.chooseUserDataID,
  logout_user_client: _auth.logout_user_client,
  updateUserSubscription: _auth.updateUserSubscription,
  showResumeNameModal: templateActions.showResumeNameModal,
  setResumeName: templateActions.setResumeName,
  loadSavedUserData: templateActions.loadSavedUserData,
  showZipRecruiterModal: _company.showZipRecruiterModal,
  saveSSODetail: authActions.saveSSODetail
}), _dec(_class = function (_Component) {
  (0, _inherits3.default)(Home, _Component);

  function Home(props) {
    (0, _classCallCheck3.default)(this, Home);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Home.__proto__ || (0, _getPrototypeOf2.default)(Home)).call(this, props));

    _this.handleAddResumeClick = function () {
      // this.setState({showTemplateNameModal: true});
      // Removed because of name feature addition.

      _this.props.updateUserSubscription();

      _this.props.cleanInfo();
      _this.props.cleanTemplateData();
      _this.props.showResumeNameModal(true);
      _this.props.ReactGA.event({
        category: 'Resume - Dashboard',
        action: 'Create New Resume',
        label: 'Time: ' + Date.now() + ' Page Title: ' + window.location.href
      });
      // this.props.pushState(this.props.base_url + '/choose-design');
      // if(this.props.company_data.name == 'Edureka') this.props.updateUserSubscription();
    };

    _this.handleDeleteIconClick = function (template) {
      var confirm = window.confirm('Are you sure you want to delete this Resume?\n If you proceed, you will not be able to recover the data in this Resume.');
      if (confirm) {
        _this.props.deleteUserData(template);
      }
    };

    _this.handleCopyIconClick = function (user_data) {

      _this.props.cleanInfo();
      _this.props.cleanTemplateData();

      _this.props.loadSavedUserData(user_data.id);

      _this.props.showResumeNameModal(true);
      // Setting Design Template.
      // this.props.setResumeName(user_data.name_of_template);
      // if basic_builder choose design as basic builder design
      if (_this.props.basic_builder) {
        _this.props.choose_template(_this.props.basic_builder_design);
      } else {
        _this.props.choose_template(user_data.design_template);
      }

      //  // this.props.pushState(this.props.base_url + '/design-view');
      // this.props.saveUserData(object);
      // this.props.loadUserData();
    };

    _this.state = {
      data: false,
      template_data: false,
      user_data: _this.props.user_data,
      showTemplateNameModal: false,
      inputValueResumeName: false,
      show_max_resume_warning: false
    };
    return _this;
  }

  (0, _createClass3.default)(Home, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      // console.log(this.props.user_data);
      /*
      if (!this.props.user && nextProps.user) {
        // login
        this.props.pushState('/loginSuccess');
      } else if (this.props.user && !nextProps.user) {
        // logout
        this.props.pushState('/');
      }
      */
      if ((0, _keys2.default)(this.props.full_sso_data).length && !this.props.sso_detail) {
        this.props.saveSSODetail(this.props.full_sso_data);
      }
      this.setState({ template_data: this.props.template_data });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      // This is case for edureka when server session is lost
      // But user is logged in on client
      // if(!this.props.user_data_fail && nextProps.user_data_fail && !nextProps.user_data_loading && !nextProps.user_data_loaded) {
      //   console.log('inside');
      //   this.props.logout_user_client();
      // }
      if (this.props.basic_builder_design && !this.props.resume_name && nextProps.resume_name) {
        this.props.pushState(this.props.base_url + '/design-view');
      }

      if (!this.props.basic_builder_design) {
        if (nextProps.resume_name && !this.props.resume_name) {
          this.props.pushState(this.props.base_url + '/choose-design/?q=new_resume');
          // if(this.props.company_data.name == 'Edureka') this.props.updateUserSubscription();
        }
      }

      // TODO: Fix to only change url when you get change and also add a loader to signify click done
      // if(nextProps.user_data_id != this.props.user_data_id) {
      //   this.props.pushState(this.props.base_url + '/design-view');
      // }
      if (!nextProps.user && this.props.user) {
        // this.props.pushState(this.props.base_url + '');
      }
      if (this.props.user_data.load_data != nextProps.user_data.load_data) {
        this.setState({ user_data: nextProps.user_data });
      }
    }
  }, {
    key: 'getImageURL',
    value: function getImageURL(id) {
      var company_design_templates = this.props.company_data.design_templates;
      var company_design_templates_array = (0, _values2.default)(company_design_templates);
      for (var i = 0; i < company_design_templates_array.length; i++) {
        for (var j = 0; j < company_design_templates_array[i].length; j++) {
          if (company_design_templates_array[i][j].id === id) {
            return company_design_templates_array[i][j].image_url;
          }
        }
      }
    }
  }, {
    key: 'getDesignTemplateName',
    value: function getDesignTemplateName(id) {
      for (var key in this.props.company_data.design_templates) {
        var company_design_templates = this.props.company_data.design_templates[key];
        for (var i = 0; i < company_design_templates.length; i++) {
          if (id === company_design_templates[i].id) {
            return company_design_templates[i].name;
          }
        }
      }
    }
  }, {
    key: 'getContentTemplateName',
    value: function getContentTemplateName(id) {
      for (var key in this.props.company_data.content_templates) {
        var company_design_templates = this.props.company_data.content_templates[key];
        for (var i = 0; i < company_design_templates['data'].length; i++) {
          if (id === company_design_templates['data'][i].id) {
            return company_design_templates['data'][i].name;
          }
        }
      }
    }
  }, {
    key: 'getLastEditTime',
    value: function getLastEditTime(date) {
      var d = new Date(date);
      var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
      var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

      var day = days[d.getDay()];
      var hr = d.getHours();
      var min = d.getMinutes();
      if (min < 10) {
        min = '0' + min;
      }
      var ampm = hr < 12 ? ' am' : ' pm';
      var date = d.getDate();
      var month = months[d.getMonth()];
      var year = d.getFullYear();
      return 'Last Saved: ' + ' ' + hr + ':' + min + ampm + ' ' + date + ' ' + month + ' ' + year;
    }
  }, {
    key: 'resume',
    value: function resume(user_data) {

      this.props.ReactGA.set({ dimension1: this.getDesignTemplateName(user_data.design_template) });
      this.props.ReactGA.set({ dimension2: this.getContentTemplateName(user_data.content_template) });
      this.props.ReactGA.event({
        category: 'Resume - Dashboard',
        action: 'View my resume: ' + this.getDesignTemplateName(user_data.design_template) + ' - ' + this.getContentTemplateName(user_data.content_template),
        label: 'Time: ' + Date.now() + ' Page Title: ' + window.location.href
      });
      // Clean existing data  before proceeding
      this.props.cleanInfo();
      this.props.cleanTemplateData();
      // TODO: testing phase for new methods. Single Reducer.
      // user_data.info_block
      // .map((data, index) =>
      //   this.props.addInfo(data)
      // );
      // console.log(user_data);
      // Adding personal info of the user
      // this.props.updatePersonalDetails(user_data.personal_info);
      // Adding professional info of the user
      // user_data.professional_info
      // .map((data, index) =>
      //   this.props.addProfessionalDetails(data)
      // );
      // Adding miscellaneous infor of the user
      // user_data.miscellaneous_info
      // .map((data, index) =>
      //   this.props.addMiscellaneousInfo(data)
      // );
      // Setting Design Template.
      this.props.setResumeName(user_data.name_of_template);
      // if basic_builder choose design as basic builder design
      if (this.props.basic_builder) {
        this.props.choose_template(this.props.basic_builder_design);
      } else {
        this.props.choose_template(user_data.design_template);
      }
      // this.props.loadDesignTemplateData(user_data.design_template);
      // Setting Content Template.
      // this.props.loadContentTemplateData(user_data.content_template.id);
      // this.props.loadSavedUserData(user_data.id);
      // Changing The url to design view so user can proceed with editing.
      this.props.chooseUserDataID(user_data.id);

      this.props.pushState(this.props.base_url + '/design-view/' + user_data.slug);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var logoImage = require('./Hiration_Logo.png');
      if (this.state.user_data.loaded_data && this.state.user_data.load_data) {
        var cardWidth = this.props.type_of_document == 'Personal Website' ? 400 : 210;
        var CardColumnCount = function CardColumnCount() {
          return _react2.default.createElement(
            _semanticUiReact.Card.Group,
            {
              style: { marginTop: 8, display: 'flex', justifyContent: 'center' },
              itemsPerRow: 4 },
            _new_cards
          );
        };
        var _new_cards = this.state.user_data.load_data.map(function (template, index) {
          return _react2.default.createElement(
            _semanticUiReact.Card,
            {
              link: true,
              key: index,
              style: { width: cardWidth, marginLeft: '2.5em', marginRight: '2.5em', marginBottom: '50px' },
              raised: true },
            _react2.default.createElement(_semanticUiReact.Image, { onClick: function onClick() {
                _this2.resume(template);
              }, src: _this2.getImageURL(template.design_template) }),
            _react2.default.createElement(
              _semanticUiReact.Card.Content,
              { onClick: function onClick() {
                  _this2.resume(template);
                } },
              _react2.default.createElement(
                _semanticUiReact.Card.Header,
                { style: { textAlign: 'center', color: 'black' } },
                template.name_of_template
              ),
              _react2.default.createElement(
                _semanticUiReact.Card.Description,
                { style: { textAlign: 'center', color: 'black' } },
                _this2.getContentTemplateName(template.content_template)
              )
            ),
            _react2.default.createElement(
              _semanticUiReact.Card.Content,
              { style: { cursor: 'default' }, extra: true },
              _this2.props.show_resume_edit_label && _react2.default.createElement(
                _semanticUiReact.Label,
                { as: 'a', ribbon: true },
                _react2.default.createElement(_semanticUiReact.Popup, {
                  trigger: _react2.default.createElement(_semanticUiReact.Icon, { onClick: function onClick() {
                      return _this2.handleDeleteIconClick(template);
                    }, style: { cursor: 'pointer' }, name: 'trash' }),
                  content: 'Click here to delete this ' + _this2.props.type_of_document + '.'
                }),
                _react2.default.createElement(_semanticUiReact.Popup, {
                  trigger: _react2.default.createElement(_semanticUiReact.Icon, { onClick: function onClick() {
                      return _this2.handleCopyIconClick(template);
                    }, style: { cursor: 'pointer' }, name: 'copy' }),
                  content: 'Click here to create a copy of this ' + _this2.props.type_of_document + '.'
                })
              ),
              _react2.default.createElement(
                'div',
                { style: { textAlign: 'center' } },
                _this2.getLastEditTime(template.time_create)
              )
            )
          );
        });
        return _react2.default.createElement(
          'div',
          { style: { paddingLeft: 50, paddingTop: 50, paddingRight: 50 } },
          _react2.default.createElement(_components.UserProgress, { designScreen: false, homeScreen: true }),
          _react2.default.createElement(_semanticUiReact.Button, {
            onClick: function onClick() {
              //need to check for subscription here
              // if ( (this.props.max_resumes < 0) || (this.state.user_data.load_data.length < this.props.max_resumes)){
              _this2.handleAddResumeClick();
              // }else{
              //   alert('Oops! Looks like you\'ve reached the Max resume limit. Upgrade to a premium account or delete an existing resume to create more resumes!');
              // }
            },
            content: 'New ' + this.props.type_of_document,
            icon: 'add',
            labelPosition: 'left',
            style: { marginBottom: 20 } }),
          this.props.company_data.show_zip_recruiter && _react2.default.createElement(_semanticUiReact.Button, {
            onClick: function onClick() {
              // this.setState({showTemplateNameModal: true});
              // Removed because of name feature addition.
              _this2.props.showZipRecruiterModal(true);
              _this2.props.ReactGA.event({
                category: 'Resume - Dashboard',
                action: 'Clicked on Job button',
                label: 'Time: ' + Date.now() + ' Page Title: ' + window.location.href
              });
              // this.props.pushState(this.props.base_url + '/choose-design');
              // if(this.props.company_data.name == 'Edureka') this.props.updateUserSubscription();
            },
            content: 'Jobs',
            icon: 'search',
            labelPosition: 'left',
            style: { marginBottom: 20, float: 'right' } }),
          this.state.user_data.load_data && _react2.default.createElement(
            _semanticUiReact.Segment,
            { style: { backgroundColor: 'rgba(245, 245, 245 , .5)' } },
            _react2.default.createElement(
              _semanticUiReact.Label,
              { ribbon: true, color: 'black' },
              'My ',
              this.props.type_of_document,
              's'
            ),
            _react2.default.createElement(CardColumnCount, null)
          )
        );
      } else {
        return _react2.default.createElement(
          _semanticUiReact.Segment,
          { style: { minHeight: 800 } },
          _react2.default.createElement(
            _semanticUiReact.Dimmer,
            { active: true },
            _react2.default.createElement(_semanticUiReact.Loader, null)
          )
        );
      }
    }
  }]);
  return Home;
}(_react.Component)) || _class);
exports.default = Home;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Home/Home.js
// module id = 1760
// module chunks = 0